import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="section-title">最新快讯</h2>
          <p className="section-subtitle">实时追踪娱乐圈最新动态，不错过任何一条爆料</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10">
            <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-background-200"></div>

            {updateItems.map((item, idx) => (
              <div key={item.id} className="relative pb-6 last:pb-0">
                <div className={`absolute left-0 top-1.5 -translate-x-[calc(0.5rem+1px)] w-3 h-3 md:w-3.5 md:h-3.5 rounded-full border-2 border-background-50 ${
                  idx === 0 ? 'bg-primary-500' : 'bg-background-300'
                }`}></div>

                <div className="ml-4 md:ml-6 bg-background-50 rounded-xl border border-background-200/70 p-4 md:p-5 hover:border-primary-200 transition-all cursor-pointer">
                  <div className="flex flex-wrap items-center gap-2 mb-1.5">
                    <span className="text-xs text-primary-600 font-semibold">{item.time}</span>
                    <span className="text-xs bg-secondary-100 text-secondary-700 px-2 py-0.5 rounded-full font-medium">
                      {item.category}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-900 leading-relaxed">
                    {item.title}
                  </h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}